export default "__VITE_ASSET__BPa_l60M__"